<flow-header [title]="customerId ? 'editCustomer.title' : 'createCustomer.title' | translate">
  <div class="flex flex-1 items-center justify-end gap-4">
    <flow-button theme="secondary" variation="outline" [routerLink]="['/customers']">
      {{ 'global.cancel' | translate }}
    </flow-button>

    <flow-button
      [disabled]="(loading$.save | async) || invoiceForm.invalid || customerForm.invalid"
      [isCapitalize]="false"
      theme="primary"
      variation="fill"
      (onClick)="onSaveClick()">
      {{(customerId ? 'global.saveChanges' : 'global.add') | translate}}
    </flow-button>
  </div>
</flow-header>

<div class="flex w-full mt-6">
  <flow-stepper
    class="w-full"
    [steps]="steps"
    [(activeStep)]="selectedIndex"
    (activeStepChange)="selectedTabChange($event)"
    [isEdit]="customerId == null">
    <flow-tabs-item [error]="customerValidationErrors.length > 0">
      <div class="flex flex-col p-4 mb-5 text-brand-red rounded-lg bg-red-50" role="alert" *ngIf="customerValidationErrors?.length > 0">
        <div class="flex flex-row items-center">
          <span class="font-medium">{{'createCustomer.validationErrors.requirementsMet' | translate}}</span>
        </div>
        <ul class="mt-1.5 list-disc list-inside" *ngFor="let validation of customerValidationErrors">
          <li>{{validation}}</li>
        </ul>
      </div>

      <form class="grid grid-cols-3 xl:grid-cols-4 gap-4" [formGroup]="customerForm">
        <div class="flex flex-col col-span-1 gap-4">
          <div class="flex flex-row mb-5">
            <app-icon
              fill="#BFD6E4"
              iconName="annotation-info"
              size="md"
              class="w-8 h-8 bg-chathams-blue-400 rounded-full flex justify-center items-center"
              stroke="#598FAE"></app-icon>
            <h3 class="m-0 ml-3 text-text-primary font-semibold">{{'createCustomer.permissions.subTitles.generalInfo' | translate}}</h3>
          </div>

          <flow-form-input formControlName="name" [label]="'createCustomer.form.companyName'" [required]="true"></flow-form-input>

          <flow-form-input formControlName="organizationId" [label]="'createCustomer.form.orgNumber'" [required]="false"></flow-form-input>

          <flow-form-select
            formControlName="type"
            [label]="'createCustomer.form.customerType'"
            [options]="enumService.customerTypes"
            [multiple]="false"
            [required]="true"></flow-form-select>

          <flow-form-select-country
            formControlName="country"
            label="createCustomer.form.country"
            [required]="true"
            [options]="countries$ | async"></flow-form-select-country>

          <flow-form-select-currency formControlName="currency" label="client.form.currency" [options]="currencies" [required]="true">
            <div suffix class="px-3">
              <app-icon size="md" iconName="{{CurrencyEnum[customerForm.get('currency').value]}}"></app-icon>
            </div>
          </flow-form-select-currency>

          <flow-form-select
            formControlName="pricingModel"
            label="global.pricingModel"
            [options]="pricingModels"
            [multiple]="false"
            [required]="true"></flow-form-select>

          <flow-form-input
            formControlName="numbersOfWeekForFiltering"
            label="createCustomer.form.numbersOfWeekForFiltering"
            type="number"
            [minNumber]="1"
            [required]="false"></flow-form-input>

          <div class="grid grid-cols-2 gap-4">
            <flow-form-input
              formControlName="presentationTime"
              [label]="'createCustomer.form.presentationTime'"
              [placeholder]="'editEngagement.presentationTimePlaceholder'"
              type="number"
              [minNumber]="3"
              [maxNumber]="999"
              (keypressEvent)="restrictNonNumericalInput($event)"
              (inputEvent)="removeLeadingZero($event)"
              [errorMessage]="'createScreen.validationErrors.presentationTime'"></flow-form-input>

            <flow-form-input
              formControlName="storageLimitSize"
              label="createCustomer.form.storageLimitSize"
              type="number"
              [minNumber]="1"
              [required]="false"></flow-form-input>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <flow-form-input
              formControlName="personOfInterestLimit"
              label="createCustomer.form.poiLimit"
              type="number"
              [minNumber]="1"
              [required]="false"></flow-form-input>

            <flow-form-input
              formControlName="contactPersonLimit"
              label="createCustomer.form.contactPersonLimit"
              type="number"
              [minNumber]="1"
              [required]="false"></flow-form-input>
          </div>

          <div *ngIf="customerId" class="flex flex-row items-end">
            <div class="w-full justify-start items-end gap-2 inline-flex">
              <div class="flex flex-col flex-1">
                <mat-label>{{ "createCustomer.form.contact" | translate }}</mat-label>
                <mat-form-field appearance="outline" class="multi-select-field flex-1">
                  <mat-select formControlName="contactPersons" multiple>
                    <mat-select-trigger>
                      <div *ngFor="let person of selectedContactPersons">{{person.name}} - {{ person.phoneNumber }}</div>
                    </mat-select-trigger>
                    <mat-option *ngFor="let person of customerPersons; let i = index" [value]="person">
                      <div class="flex">
                        <span class="flex-1">{{ person.name }} - {{ person.phoneNumber }}</span>
                        <button
                          class="btn-edit-customer-person"
                          mat-icon-button
                          (click)="onCreateCustomerPerson(person, i, $event)"
                          color="accent">
                          <mat-icon>edit</mat-icon>
                        </button>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <a (click)="onCreateCustomerPerson()" class="mb-1 p-2 bg-neutral-50 rounded justify-start items-start gap-2 flex">
                <app-icon [ngStyle]="{cursor:'pointer'}" iconName="plus" size="md" stroke="#202020"></app-icon>
              </a>
            </div>
          </div>
          <!-- <div class="w-[362px] h-fit p-4 bg-neutral-50 flex-col justify-start items-start gap-4 inline-flex">
              <div class="self-stretch h-[71px] flex-col justify-start items-start gap-2 flex">
                <mat-label class="text-gray-900 text-sm font-normal leading-[14px]">{{'createCustomer.form.contactPerson.name' | translate}} *</mat-label>
                <mat-form-field class="w-full bg-white rounded-md">
                  <input matInput
                         type="text"
                         formControlName="name">
                </mat-form-field>
              </div>
              <div class="self-stretch h-[71px] flex-col justify-start items-start gap-2 flex">
                <mat-label class="text-gray-900 text-sm font-normal leading-[14px]">{{'createCustomer.form.contactPerson.email' | translate}} *</mat-label>
                <mat-form-field class="w-full bg-white rounded-md">
                  <input matInput
                         type="text"
                         formControlName="email">
                </mat-form-field>
              </div>
              <div class="self-stretch justify-start items-end gap-4 inline-flex">
                <div class="w-full flex flex-col">
                  <mat-label class="text-gray-900 text-sm font-normal leading-[14px]">{{'createCustomer.form.contactPerson.phone' | translate}} *</mat-label>
                  <mat-form-field class="w-full bg-white rounded-md">
                    <input matInput
                           type="text"
                           formControlName="phone">
                  </mat-form-field>
                </div>
                <div (click)="onCreateCustomerPerson()" class="w-fit h-fit p-2 bg-surface-surface-brand rounded justify-center items-center gap-2 inline-flex">
                  <app-icon stroke="#fafafa" width="24px" height="24px" [iconName]="selectedMedia ? 'checked' : 'plus'"></app-icon>
                </div>
              </div>
            </div>
            <div class="w-full h-fit flex flex-col gap-4">
              <div *ngFor="let contactPerson of customerPersons; let i = index"
                   class="w-[365px] justify-between items-center inline-flex p-1 border-b border-gray-200"
                   [ngClass]="contactPerson.id != selectedContact?.id ? 'bg-gray-50' : 'bg-chathams-blue-400'">
                <div class="flex gap-2 cursor-pointer">
                  <div (click)="onCreateCustomerPerson(contactPerson)"
                        class="p-2 bg-gray-50 rounded justify-start items-start gap-2 flex">
                    <app-icon [ngStyle]="{cursor:'pointer'}"
                              iconName="edit-pencil"
                              size="md"
                              stroke="#202020">
                    </app-icon>
                  </div>
                  <div (click)="onCreateCustomerPerson(contactPerson, i)"
                        class="p-2 bg-gray-50 rounded justify-start items-start gap-2 flex">
                    <app-icon [ngStyle]="{cursor:'pointer'}"
                              iconName="x"
                              size="md"
                              stroke="#202020">
                    </app-icon>
                  </div>
                </div>
              </div>
            </div> -->
        </div>
        <div class="flex flex-col col-span-1 text-xs">
          <p class="border-l-4 border-chathams-blue-600 pl-1">{{'createCustomer.permissions.notes.title' | translate}}</p>
          <p>{{'createCustomer.permissions.notes.generalInfo' | translate}}</p>
        </div>
        <div class="hidden xl:flex"></div>
        <div class="flex flex-col col-span-1 items-end justify-start">
          <flow-button theme="primary" variation="fill" (onClick)="onNextTab(1)" [disabled]="loading$.save | async">
            {{ "global.next" | translate }}
          </flow-button>
        </div>
      </form>
    </flow-tabs-item>
    <flow-tabs-item [error]="invoiceValidationErrors.length > 0">
      <div class="flex flex-col p-4 mb-5 text-brand-red rounded-lg bg-red-50" role="alert" *ngIf="invoiceValidationErrors?.length > 0">
        <div class="flex flex-row items-center">
          <span class="font-medium">{{'createCustomer.validationErrors.requirementsMet' | translate}}</span>
        </div>
        <ul class="mt-1.5 list-disc list-inside" *ngFor="let validation of invoiceValidationErrors">
          <li>{{validation}}</li>
        </ul>
      </div>

      <form class="grid grid-cols-3 xl:grid-cols-4 gap-4" [formGroup]="invoiceForm">
        <div class="flex flex-col col-span-1 gap-4">
          <div class="flex flex-row mb-5">
            <app-icon
              fill="#BFD6E4"
              iconName="invoice"
              size="md"
              class="w-8 h-8 bg-chathams-blue-400 rounded-full flex justify-center items-center"
              stroke="#598FAE"></app-icon>
            <h3 class="m-0 ml-3 text-text-primary font-semibold">{{'createCustomer.permissions.subTitles.invoice' | translate}}</h3>
          </div>

          <flow-form-input formControlName="address" label="createCustomer.form.address" [required]="false"></flow-form-input>

          <div class="grid lg:grid-cols-2 gap-4">
            <flow-form-input formControlName="postalCode" label="createCustomer.form.postalCode" [required]="false"></flow-form-input>
            <flow-form-input formControlName="postalCity" label="createCustomer.form.county" [required]="false"></flow-form-input>
          </div>

          <flow-form-select
            formControlName="invoiceDeliveryType"
            label="createCustomer.form.deliveryType"
            [options]="enumService.invoiceDeliveryTypes"
            [multiple]="false"
            [required]="false"></flow-form-select>

          <flow-form-input
            *ngIf="invoiceForm.value?.invoiceDeliveryType === InvoiceDeliveryTypeEnum.Email"
            formControlName="invoiceDeliveryEmail"
            label="createCustomer.form.ePostAddress"
            [required]="true"></flow-form-input>

          <flow-form-input formControlName="referenceName" label="createCustomer.form.reference" [required]="false"></flow-form-input>
        </div>

        <div class="flex flex-col col-span-1 text-xs">
          <p class="border-l-4 border-chathams-blue-600 pl-1">{{'createCustomer.permissions.notes.title' | translate}}</p>
          <p>{{'createCustomer.permissions.notes.invoiceInfo' | translate}}</p>
        </div>

        <div class="hidden xl:flex"></div>

        <div class="flex flex-row col-span-1 gap-4 items-start justify-end">
          <flow-button theme="secondary" variation="outline" (onClick)="onNextTab(0)">
            {{ "global.back" | translate }}
          </flow-button>

          <flow-button theme="primary" variation="fill" (onClick)="onNextTab(2)" [disabled]="loading$.save | async">
            {{ "global.next" | translate }}
          </flow-button>
        </div>
      </form>
    </flow-tabs-item>
    <flow-tabs-item>
      <div class="w-full flex flex-col gap-8">
        <div class="grid grid-cols-3 xl:grid-cols-4 gap-4">
          <div class="flex flex-row flex-1 mb-5">
            <app-icon
              fill="#BFD6E4"
              iconName="lock"
              size="md"
              class="w-8 h-8 bg-chathams-blue-400 rounded-full flex justify-center items-center"
              stroke="#598FAE"></app-icon>
            <h3 class="m-0 ml-3 text-text-primary font-semibold">{{'createCustomer.permissions.subTitles.permissions' | translate}}</h3>
          </div>

          <div class="row row-col text-xs">
            <p class="border-l-4 border-chathams-blue-600 pl-1">{{'createCustomer.permissions.notes.title' | translate}}</p>
            <p>{{'createCustomer.permissions.notes.allocatePermissions' | translate}}</p>
          </div>
          <div class="hidden xl:flex"></div>
          <div class="flex flex-row items-start justify-end">
            <flow-button theme="secondary" variation="outline" (onClick)="onNextTab(1)">
              {{ "global.back" | translate }}
            </flow-button>
          </div>
        </div>
        <form [formGroup]="permissionsForm" *ngIf="permissionsForm">
          <table class="min-w-full divide-y divide-gray-200" formArrayName="permissions">
            <thead>
              <tr>
                <th scope="col" class="py-3.5 px-4 text-sm font-semibold text-left">
                  {{'createCustomer.permissions.actions.headers.actions' | translate}}
                </th>

                <th scope="col" class="px-12 py-3.5 text-sm font-semibold text-center">
                  {{'createCustomer.permissions.actions.headers.view' | translate}}
                </th>

                <th scope="col" class="px-4 py-3.5 text-sm font-semibold text-center">
                  {{'createCustomer.permissions.actions.headers.update' | translate}}
                </th>

                <th scope="col" class="px-4 py-3.5 text-sm font-semibold text-center">
                  {{'createCustomer.permissions.actions.headers.export' | translate}}
                </th>
              </tr>
            </thead>
            <tbody
              class="bg-white divide-y divide-gray-200"
              *ngFor="let header of permissionsArray.controls; let headerIndex = index"
              [formGroupName]="headerIndex">
              <tr class="bg-gray-200">
                <td colspan="5">
                  <span class="flex px-3 py-2">
                    {{ 'createCustomer.permissions.headers.' + header.get('header').value | translate}}
                  </span>
                </td>
              </tr>

              <ng-container class="flex flex-col" formArrayName="actions">
                <tr *ngFor="let action of getActionsArray(headerIndex).controls; let actionIndex = index" [formGroupName]="actionIndex">
                  <td class="p-3">
                    <div class="flex flex-row items-center">
                      <app-icon
                        *ngIf="action.get('icon').value"
                        class="mr-3"
                        stroke="#595959"
                        fill="#fff"
                        iconName="{{action.get('icon').value}}"
                        size="md"></app-icon>
                      <h4 class="m-0 p-0 leading-4">
                        {{ 'createCustomer.permissions.actions.body.' + action.get('title').value | translate}}
                      </h4>
                    </div>
                  </td>
                  <ng-container class="flex flex-row items-center" formArrayName="permissions">
                    <td
                      class="w-2/12 px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center"
                      *ngFor="let permission of getPermissionsArray(headerIndex, actionIndex).controls; let permissionIndex = index"
                      [formGroupName]="permissionIndex">
                      <mat-checkbox *ngIf="permission.value.hiddenValue !== null" color="primary" formControlName="value"></mat-checkbox>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </form>
      </div>
    </flow-tabs-item>
  </flow-stepper>
</div>
